import React, { useState, useEffect } from 'react';
import './Home.css';
import { storage } from '../firebase';
import { ref, listAll, getDownloadURL } from 'firebase/storage';

const Home = () => {
  const [members, setMembers] = useState([]);

  const FIREBASE_FUNCTION_URL = 'us-central1-gsp-website-553a2.cloudfunctions.net';

  const handleScroll = () => {
    window.scrollBy({
      top: 400, // Adjust this value to control how much it scrolls
      behavior: 'smooth',
    });
  };

  useEffect(() => {
  const cachedMembers = localStorage.getItem('members');

    if (cachedMembers) {
      // If members are available in localStorage, use them
      setMembers(JSON.parse(cachedMembers));
    } else {
      // Otherwise, fetch from Firebase and store in localStorage
      fetch(`https://${FIREBASE_FUNCTION_URL}/getMembers`)
        .then(response => response.json())
        .then(data => {
          setMembers(data);
          // Store the fetched data in localStorage
          localStorage.setItem('members', JSON.stringify(data));
        })
        .catch(error => {
          console.error('Error fetching members:', error);
        });
    }
  }, [FIREBASE_FUNCTION_URL]);

  return (
    <div className="home-container">
      <div className="top-section" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg.jpg)` }}>
        <div className="overlay-gradient">
          <div className="main-text">
            <h1>Welcome to UTD GSP</h1>
          </div>
          <div className="scroll-icon" onClick={handleScroll}></div>
        </div>
      </div>

      <div className="home-body">
        <h1 className="section-head">WHAT WE ARE</h1>

        <div className="section points">
          <div className="text-box">
            <p>
              As every graduate program aspires to be a
              cohesive cohort of scholars, this organization
              aims to fortify our community of academics and
              students in the UTD Physics Department and
              shall foster avenues for students to improve their
              communication abilities to a particular audience
              about their work, or physics in general.
            </p>
          </div>
          <div className="photo-box">
            <img src={`${process.env.PUBLIC_URL}/images/home/1.png`} alt="Logo"/>
          </div>
        </div>

        <h1 className="section-head">WHAT WE DO</h1>
        <div className="section points reverse-layout">
          <div className="text-box-left">
            <h2>Grants & Fellowships</h2>
            <p>
            Apply for grants or fellowships at link below.
            </p>
            <p>
              <a href="https://www.utdallas.edu/nsm/scholarships" className="explore-events-btnr">Link</a>
            </p>
          </div>
          <div className="photo-box">
            <img src={`${process.env.PUBLIC_URL}/images/resources/2.png`} alt="Logo"/>
          </div>
        </div>

        <div className="section points">
          <div className="photo-box">
            <img src={`${process.env.PUBLIC_URL}/images/home/2.png`} alt="Presentation Committee"/>
          </div>
          <div className="text-box">
            <h1>Presentation Committee</h1>
            <ul>
              <li>Student-run colloquia</li>
              <li>For students, by students</li>
              <li>Helps with public speaking, trains for conference talks</li>
              <li>GSP invited talks in physics colloquia (upcoming colloquium on 9th Oct)</li>
            </ul>
          </div>
        </div>

        <div className="section points reverse-layout">
          <div className="text-box-left">
            <h1>Qualifier Help</h1>
            <ul>
              <li>Past qualifier exams available</li>
              <li>Study sessions for individual subjects to be held later in Fall semester</li>
            </ul>
          </div>
          <div className="photo-box">
            <img src={`${process.env.PUBLIC_URL}/images/home/3.png`} alt="Qualifier Help"/>
          </div>
        </div>

        <div className="section points">
          <div className="photo-box">
            <img src={`${process.env.PUBLIC_URL}/images/home/4.png`} alt="Astro"/>
          </div>
          <div className="text-box">
            <h1>Astro</h1>
            <ul>
              <li>Telescope training nights</li>
              <li>Celestial viewing (on interesting nights, weather permitting)</li>
            </ul>
          </div>
        </div>

        <div className="section points reverse-layout">
          <div className="text-box-left">
            <h1>Social Committee</h1>
            <ul>
              <li>Organize one or two larger events each semester for students and staff to gather</li>
            </ul>
          </div>
          <div className="photo-box">
            <img src={`${process.env.PUBLIC_URL}/images/home/5.png`} alt="Social Committee"/>
          </div>
        </div>
      </div>

      <div className="section-bottom">
        <div className="events-button">
          <a href="/events" className="explore-events-btn">Explore Events</a>
        </div>

        <h1 className="section-head">WHO WE ARE</h1>
        <div className="core-members">
          {members.map((member, index) => (
            <div key={index} className="member">
              <img src={member.photoURL} alt={member.name} />
            </div>
          ))}
        </div>

        <div className="events-button">
          <a href="/about" className="explore-events-btn">Meet Our Team</a>
        </div>
      </div>

    </div>
  );
};

export default Home;
